import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { startMetaTracking } from './tracking/startMetaTracking';

startMetaTracking();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
